export const _state = {
    isGetRegulationsFetch: false,
    isPostRegulationFetch: false,
    isPutRegulationFetch: false,
    isDeleteRegulationFetch: false,
    errors: {},
    regulation: {},
    regulations: [],
};

export function regulationsReducer(state = _state, action) {

    switch (action.type) {

        case 'REGULATIONS_INITIALIZE':
            return {
                ...state,
                regulations: [],
            };

        case 'CLEAR_REGULATION_ERRORS':
            return {
                ...state,
                errors: {},
            };

        case 'API_GET_REGULATIONS_CLOSE_FETCH':
            return {
                ...state,
                isGetRegulationsFetch: false,
            };

        case 'API_POST_REGULATION_CLOSE_FETCH':
            return {
                ...state,
                isPostRegulationFetch: false,
            };

        case 'API_PUT_REGULATION_CLOSE_FETCH':
            return {
                ...state,
                isPutRegulationFetch: false,
            };

        case 'API_DELETE_REGULATION_CLOSE_FETCH':
            return {
                ...state,
                isDeleteRegulationFetch: false,
            };

        case 'API_GET_REGULATIONS':
            return {
                ...state,
                isGetRegulationsFetch: true
            };

        case 'API_GET_REGULATIONS_SUCCESS':
            return {
                ...state,
                regulations: action.payload.data,
                errors: {},
            };

        case 'API_GET_REGULATIONS_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_CREATE_REGULATION':
            return {
                ...state,
                isPostRegulationFetch: true,
            };

        case 'API_CREATE_REGULATION_SUCCESS':
            return {
                ...state,
                errors: {},
                regulation: action.payload.data,
            };

        case 'API_CREATE_REGULATION_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_UPDATE_REGULATION':
            return {
                ...state,
                isPutRegulationFetch: true,
            };

        case 'API_UPDATE_REGULATION_SUCCESS':
            return {
                ...state,
                errors: {},
                regulation: action.payload.data,
            };

        case 'API_UPDATE_REGULATION_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_DELETE_REGULATION':
            return {
                ...state,
                isDeleteRegulationFetch: true,
            };

        case 'API_DELETE_REGULATION_SUCCESS':
            return {
                ...state,
                regulation: {},
            };

        case 'API_DELETE_REGULATION_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'SET_EDIT_REGULATION':
            return {
                ...state,
                regulation: action.payload.regulation,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/regulations.js